/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { ModalContent as ChakraModalContent, ModalContentProps } from '@chakra-ui/react'
import { useTheme } from '@emotion/react'
import { Z_INDEX_MODAL } from '@zcode-ui/themes'
import React, { useContext } from 'react'

import { ModalContext } from './Modal'
import * as styles from './styles'

interface Props extends ModalContentProps {}

export const MODAL_SIZE_TO_WIDTH: Record<string, string> = {
  xs: '320px',
  sm: '400px',
  md: '480px',
  lg: '560px',
  xl: '640px',
  '2xl': '640px',
  '3xl': '720px',
  '4xl': '800px',
  '5xl': '880px',
  '6xl': '960px',
  full: '100%',
}

const fullSize = {
  minWidth: '100%',
  minHeight: '100%',
  marginTop: 0,
  marginBottom: 0,
  borderRadius: 0,
}

export const ModalContent = ({ css, containerProps, style, ...rest }: Props) => {
  const { customWidth, isCentered, size } = useContext(ModalContext)
  const { spacing } = useTheme()
  const maxWidth = {
    maxWidth:
      typeof customWidth !== 'undefined' && customWidth !== ''
        ? customWidth
        : MODAL_SIZE_TO_WIDTH[size ?? 'md'],
  }
  const sizeStyle = size === 'full' ? fullSize : maxWidth
  const marginStyle = {
    marginTop: spacing.spacing9,
    marginBottom: spacing.spacing9,
    marginLeft: 'auto',
    marginRight: 'auto',
  }
  const extra = {
    ...maxWidth,
    ...marginStyle,
    ...sizeStyle,
  }
  return (
    <ChakraModalContent
      containerProps={{
        justifyContent: 'center',
        overflow: 'auto',
        alignItems: isCentered ? 'center' : 'flex-start',
        zIndex: Z_INDEX_MODAL,
        display: fullSize ? 'block' : 'flex',
        height: '100vh !important',
        ...containerProps,
      }}
      css={[styles.content, css]}
      style={{ ...extra, ...style }}
      {...rest}
    />
  )
}
